<template>
    <div class="w-full h-full">
        <ais-instant-search
                :search-client="searchClient"
                index-name="items"
        >
            <ais-configure
                    :hits-per-page.camel="5"
                    :restrict-searchable-attributes.camel="['descrizione', 'id_articolo']"
            />
            <ais-autocomplete>
                <template slot-scope="{ currentRefinement, indices, refine }">
                    <vue-autosuggest
                            :suggestions="indicesToSuggestions(indices)"
                            v-model="value"
                            @input="refine"
                            @selected="onSelect"
                            :input-props="{
                                style: 'width: 100%',
                                placeholder: 'Search here…',
                             }"
                            :get-suggestion-value="getSuggestionValue"
                    >
                        <template slot-scope="{ suggestion }">
                            <div>
                                <strong>{{ suggestion.item.id_articolo }}</strong> - {{
                                suggestion.item.descrizione }}
                            </div>
                        </template>
                    </vue-autosuggest>
                </template>
            </ais-autocomplete>
        </ais-instant-search>
    </div>
</template>

<script>
    import Searchable from "../../mixins/Searchable";
    import EditCell from "../../mixins/EditCell";

    export default {

        mixins: [Searchable, EditCell],

        data() {

            return {
                value: this.data,
                properties: {
                    style: 'width: 100%',
                    placeholder: 'Search here ...',
                }
            }
        },

        methods: {
            onSelect(selected) {
                if (selected) {
                    this.value = selected.item.id_articolo;

                    let data = {};

                    data[this.field] = this.value;

                    this.persist(data);
                }
            }
        }

    }
</script>

<style scoped>

</style>